<div class="bottom-20 glass-blurred-background drop-shadow" *ngFor="let contract of filteredContractList; let i=index;"
     (click)="openContract(contract.id)">

    


    <div class="flex-row ion-align-items-center ion-justify-content-center">
        <div class="text-bold font-20"> {{ contract.product  }}</div>

    </div>  <div class="flex-row ion-align-items-center ion-justify-content-center">
        <div class="">Investimento: {{ contract.amount | currency:'EUR' }}</div>

    </div>



    <div class="flex-row ion-align-items-center ion-justify-content-center">
        <div class="">Plusvalenza: {{ contract | interesseMaturate | currency:'EUR' }}; {{(((contract | interesseMaturate)/ contract.amount)*100)|number:'1.2-2'}}%

        </div>

    </div>


    <div class="flex-row ion-align-items-center ion-justify-content-center">
        <div class="font-20 text-bold">Montante:  {{ contract|interesseMaturate:true | currency:'EUR'}}</div>
    </div>

    <div class="flex-row ion-align-items-center ion-justify-content-center">
        <div class="font-14">        {{contract?.startDate |date:"dd/MM/yyyy" }} - {{contract.endDate|date:"dd/MM/yyyy"}}; {{contract.percent}}%

        </div>
    </div>
</div>

<div class="floating-btn drop-shadow" (click)="addContract()" >+</div>

<!-- <div class="estimates-content-div">
    <div class="">

        <p class="no-results" *ngIf="!contractsList?.length">No contract found</p>

        <ion-row class="left" *ngFor="let contract of contractsList; let i=index;trackBy: trackItem" >
            <ion-list class="client-contracts-list" [ngClass]="cssClass">
                <ion-item-sliding>
                    <ion-item class="slide-item">


                        <div class="client-contract-cnt" [ngClass]="owner?.permessions == 'CLIENT' ? 'client' : 'agent'"
                             (click)="openContract(contract.id)">

                            <div class="item-emboss"></div>

                            <div class="flex relative">
                                <div class="flex-1 text-center">
                                    <b>Prodotto</b> <br>
                                    € {{contract.amount}}
                                </div>
                                <div class="flex-1 text-center">
                                    <b>Durata</b> <br>
                                    {{contract.startDate|date:"MM/YYYY" }} - {{contract.endDate|date:"MM/YYYY"}}
                                </div>
                                <div class="flex-1 text-center">h
                                    <b>Rendimento</b> <br>
                                    {{contract.percent}}%
                                </div>
                                <div class="flex-1 text-center">
                                    <b>Interesse nat.</b> <br>
                                    € 0
                                </div>
                            </div>

                        </div>


                    </ion-item>
                    <ion-item-options side="end">

                        <ion-item-option color="success" (click)="editContract(contract.id)">Edit</ion-item-option>
                        <ion-item-option color="danger" (click)="deleteContract(contract.id)">Delete</ion-item-option>
                    </ion-item-options>
                </ion-item-sliding>
            </ion-list>
        </ion-row>
    </div>
</div>

<ion-fab vertical="bottom" horizontal="end" slot="fixed">
    <ion-fab-button class="fab-add-btn" (click)="addContract()">
        <ion-icon name="add"></ion-icon>
    </ion-fab-button>
</ion-fab> -->
